import {
  useCurrentUser,
  useCurriculum,
} from "@twinkltech/curriculum-architect-domain-hooks";

import { NewCurriculumModal } from "./NewCurriculumModal";

export const NewCurriculumModalContainer = ({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (open: boolean) => void;
}) => {
  const {
    actions: { create },
    isLoading,
  } = useCurriculum();

  const { data: currentUser } = useCurrentUser();
  const isSchoolAccount = currentUser?.persona?.accountType === "school";

  return (
    open && (
      <NewCurriculumModal
        isLoading={isLoading || create.isLoading}
        isSchoolAccount={isSchoolAccount}
        open={open}
        setOpen={setOpen}
        onHandleSubmit={create.apply}
      />
    )
  );
};
